module.exports = __webpack_public_path__ + "static/apple-icon-144x144-b17984c36ab3fcf9f1993373b065ba1e.png";